import { render, staticRenderFns } from "./Dancers.vue?vue&type=template&id=5d5f678f&scoped=true&"
import script from "./Dancers.vue?vue&type=script&lang=ts&"
export * from "./Dancers.vue?vue&type=script&lang=ts&"
import style0 from "./Dancers.vue?vue&type=style&index=0&id=5d5f678f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5f678f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5f678f')) {
      api.createRecord('5d5f678f', component.options)
    } else {
      api.reload('5d5f678f', component.options)
    }
    module.hot.accept("./Dancers.vue?vue&type=template&id=5d5f678f&scoped=true&", function () {
      api.rerender('5d5f678f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/Dancers.vue"
export default component.exports